module.exports = __webpack_public_path__ + "img/development-during-recession-top.6e8c9e96.webp";